import holidayTypes from './holidayTypes.json';
import holidayTypesContent from './holidayTypesContent.json';
import accommodationTypes from './accommodationTypes.json';
import holidayTypeUpgrade from './holidayTypeUpgrade.json';
import accommodationRanks from './accommodationRanks.json';
export const defaultData = Object.freeze({
    holidayTypes,
    holidayTypesContent,
    accommodationTypes,
    holidayTypeUpgrade,
    accommodationRanks,
});
export const getHolidayTypes = () => defaultData.holidayTypes;
export const getHolidayTypesObjByCode = (code) => defaultData.holidayTypes.find((type) => type.value === code);
export const getHolidayTypesContent = () => defaultData.holidayTypesContent;
export const getHolidayTypeUpgradeContent = () => defaultData.holidayTypeUpgrade;
export const getAccommodationRanks = () => defaultData.accommodationRanks;
export const getFilteredAccommodationTypes = (accommodationTypes) => {
    return accommodationTypes === null || accommodationTypes === void 0 ? void 0 : accommodationTypes.reduce((arr, accomType) => {
        const accType = defaultData.accommodationTypes.find((item) => item.value === accomType);
        return [...arr, ...(accType ? [accType] : [])];
    }, [{ name: 'Any', value: '' }]);
};
export const getAccommodationRankByKey = ({ accomType, accomDescription, description, }) => {
    var _a;
    const accommodationRanks = getAccommodationRanks();
    return (_a = accommodationRanks[accomType][accomDescription || description]) === null || _a === void 0 ? void 0 : _a.order;
};
